import * as Sentry from '@sentry/react';

import { systemConfig } from './systemConfig';

//ToDo do not use browser tracing in SW as it is not supported
export const initSentry = (config: { sentry?: { enable: boolean } }, release: string) => {
    if (config?.sentry?.enable) {
        Sentry.init({
            release: release,
            dsn: 'https://5be0102a3073f4fd29280613cfc64dc0@o4506869003976704.ingest.us.sentry.io/4508437618819072', // ToDo: get it from config
            sendDefaultPii: true,
            // integrations: [(new Sentry.BrowserTracing())],
            tracesSampleRate: 1.0, // Adjust this in production
            environment: systemConfig.environment,
            integrations: [
                Sentry.replayIntegration({
                    // NOTE: This will disable built-in masking. Only use this if your site has no sensitive data, or if you've already set up other options for masking or blocking relevant data, such as 'ignore', 'block', 'mask' and 'maskFn'.
                    maskAllText: false,
                    blockAllMedia: false,
                    maskAllInputs: false
                })
            ],
            // Session Replay
            replaysSessionSampleRate: 1.0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
            replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.

        });
    } else {
        console.log('Sentry is disabled');
    }
}
